<template>
  <div>
    <v-card class="my-1">
      <v-card-title>Yearly Payroll Details by Individual & Company</v-card-title>
      <v-row class="px-4">
        <v-col>
          <v-row class="px-4">
            <v-col>
              <v-autocomplete
                v-model="year"
                v-validate="'required'"
                label="Year"
                :items="years"
                :loading="loading"
                item-value="id"
                :error-messages="errors.collect('year')"
                data-vv-name="year"
                data-vv-as="year"
              />
            </v-col>

            <v-col>
              <v-autocomplete
                v-model="company"
                v-validate="'required'"
                :items="filteredCompanies"
                :loading="loading"
                label="Company"
                item-text="name"
                item-value="id"
                :error-messages="errors.collect('company')"
                data-vv-name="company"  
                data-vv-as="company"
              />
            </v-col>

            <v-col />
          </v-row>
        </v-col>

        <v-col
          cols="2"
          class="ma-auto"
        >
          <v-row
            v-if="progressing" 
            class="text-center"
          >
            <v-col cols="12">
              <div>
                <span class="font-weight-bold">Downloading</span>
              </div>
              <v-progress-circular
                :rotate="360"
                :size="50"
                :width="5"
                :value="progressbar"
                color="teal"
              >
                {{ progressbar }}
              </v-progress-circular>
            </v-col>
          </v-row>

          <v-row class="text-center">
            <v-col cols="12">
              <v-btn
                class="mx-3"
                :loading="progressing"
                color="primary"
                @click="generate"
              >
                generate
              </v-btn>
            </v-col>
          </v-row> 
        </v-col>
      </v-row>
    </v-card> 
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    props: {
      years: {
        type: Array,
        required: true,
      },
      companies: {
        type: Array,
        required: true,
      },
    },
    data () {
      return {
        progressing: false,
        progressbar: 0,
        filteredCompanies: [],
        company: null,
        year: null,
      }
    },
    created () {
      this.loading = true

      this.filteredCompanies = this.companies.filter(company => {
        return company.id !== 'ALL'
      })

      this.loading = false
    },
    methods: {
      generate () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.payrollReports().yearlyPayrollDetailsByIndividualAndCompany(this.prepareFormData(), {
              onDownloadProgress: (progressEvent) => {
                this.progressbar = (Math.floor((progressEvent.loaded * 100) / progressEvent.total))
              },
            }).then(res => {
              let blob = new Blob([res.data], { type: res.data.type })
              let link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.setAttribute('download', 'Yearly Payroll Details by Individual & Company - ' + this.year + ' [' + this.$moment().format('YYYY-MM-DD h.mma') + '].xlsx')
              link.click()

              this.progressing = false
              this.progressbar = 0

              this.$snack({ message: 'Report downloaded successfully' })
            }).catch((e) => {
              this.progressing = false

              if (e.response.status === 404) {
                this.$snack({ color: 'error', message: 'No record found' })
              } else {
                this.$snack({ color: 'error', message: 'Error! Please contact IT support' })
              }
            })
          })
      },
      prepareFormData () {
        return {
          year: this.year,
          company: this.company,
        }
      },
    },
  }
</script>
